/*
  IsoGrip – Cadeau automatique dans le panier
  Dès qu'un IsoGrip est dans le panier, le produit « Défi 21 jours – OFFERT » (0 €) est ajouté (quantité 1).
  S'il n'y a plus d'IsoGrip, le cadeau est retiré. Les IDs viennent de data-* sur la balise <script>.
*/
(() => {
  const script = document.currentScript;
  const mainProductId = Number(script.dataset.mainProduct);
  const giftVariantId = Number(script.dataset.giftVariant);
  if (!mainProductId || !giftVariantId) return;

  const nativeFetch = window.fetch.bind(window);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let busy = false;

  const refreshCart = () => {
    // Impact écoute cart:refresh pour recharger le tiroir et le compteur.
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  };

  const sync = async () => {
    if (busy) return;
    busy = true;
    try {
      const cart = await nativeFetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const hasMain = cart.items.some((item) => item.product_id === mainProductId);
      const gift = cart.items.find((item) => item.variant_id === giftVariantId);

      let changed = false;
      if (hasMain && !gift) {
        await nativeFetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1 }] })
        });
        changed = true;
      } else if (gift && (!hasMain || gift.quantity !== 1)) {
        await nativeFetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: gift.key, quantity: hasMain ? 1 : 0 })
        });
        changed = true;
      }

      if (changed) refreshCart();
    } catch (error) {
      // Le cadeau reste aussi livré par le lien de l'email de confirmation.
    } finally {
      busy = false;
    }
  };

  // Relance la synchro après chaque modification du panier faite par le thème ou une app (Rapi).
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const result = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(() => setTimeout(sync, 150)).catch(() => {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.addEventListener('pageshow', (event) => { if (event.persisted) sync(); });
})();
